import {ColDef, ColGroupDef} from "ag-grid-community";
import AbsAGGridEditViewColumn from "@/utils/UIConstants/AGGridEditViewColumns/AbsAGGridEditViewColumn.ts";
import AGGridReferenceCellEditor from "@/components/inputs/AGGridReferenceCellEditor.vue";
import AGGridReferenceCellRenderer from "@/components/inputs/AGGridReferenceCellRenderer.vue";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import AGGridEditViewMultiChoiceColumn from "@/utils/UIConstants/AGGridEditViewColumns/AGGridEditViewMultiChoiceColumn.ts";
import Translator from "@/utils/common/Translator.ts";
import FieldType from "@/utils/constants/FieldType.ts";
import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";
import ClientCache from "@/utils/login/ClientCache.ts";
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;

export default class AGGridEditViewGenericReferenceColumn extends AbsAGGridEditViewColumn
{
  constructor(column: EditScreenGridColumn, handler: EditableGridHandler) {
    super(column, handler);
  }

  override createColDef(): ColDef[] {
    let childrenColumns: (ColDef<any, any> | ColGroupDef<any>)[] = [];
    let referencedEntityType = this.columnMetadata.referencedEntityType || this.columnMetadata.defaultEntityType;
    let entityTypeColumn = Object.assign({}, this.column);
    entityTypeColumn.id += "." + CommonFieldIds.ENTITY_TYPE;
    let entityTypeMetaData = Object.assign({}, this.columnMetadata);
    entityTypeMetaData.fieldId = entityTypeColumn.id;
    entityTypeMetaData.allowedValues = ClientCache.calcAllowedValuesForEntityType(this.columnMetadata);
    entityTypeMetaData.fieldType = FieldType.EntityType;
    let multiChoiceColumn = new AGGridEditViewMultiChoiceColumn(entityTypeColumn, this.handler, entityTypeMetaData);
    let allowedValues = multiChoiceColumn.getAllowedValues();
    if (allowedValues.length === 1) {
      referencedEntityType = allowedValues[0];
    } else {
      childrenColumns.push(...multiChoiceColumn.createColDef());
    }
    let colDef = AbsAGGridEditViewColumn.defaultColDef(this);
    let headerName = colDef.headerName;
    colDef.cellRenderer = AGGridReferenceCellRenderer;
    let isShowCode = this.showsCode();
    colDef.valueFormatter = (params) => {
      const val = params.value;
      if (!val)
        return '';
      return isShowCode ? Translator.getCode(val) : Translator.getNameForFields(val);
    };
    colDef.comparator = (a, b) => AbsAGGridEditViewColumn.compareReferences(a, b, isShowCode);
    colDef.cellRendererParams = {
      isShowCode: isShowCode,
      columnId: this.id,
      referencedEntityType: referencedEntityType,
      record: this.handler.object,
      entityTypeColId: entityTypeColumn.id,
      columnMetadata: this.columnMetadata,
      handler: () => this.handler
    }
    colDef.cellEditor = AGGridReferenceCellEditor;
    colDef.cellEditorParams = {
      columnMetadata: this.columnMetadata,
      columnId: this.id,
      referencedEntityType: referencedEntityType,
      handler: () => this.handler
    };
    if (childrenColumns.length)
      childrenColumns.push(colDef);
    else
      return [colDef];
    colDef.headerName = Translator.translateId('reference');
    let groupColDef: ColGroupDef = {
      headerName: headerName,
      children: childrenColumns
    }
    return [groupColDef];
  }
}
